import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    marginTop: '32px',
    '& .iconHeader': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      '& span': {
        height: '18px',
      },
    },
  },
  rootNewLayout: {
    width: '100%',
    '& .iconHeader': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      '& span': {
        height: '18px',
      },
    },
    [theme.breakpoints.down('sm')]: {
      marginBottom: '30px',
    },
  },
  panelContainer: {
    boxShadow: '0 2px 4px 0 white',
    padding: '0 24px',
    minHeight: '80px',
    [theme.breakpoints.only('xs')]: {
      padding: '0 16px',
    },
  },
  panelContainerNewLayout: {
    boxShadow: '0 2px 4px 0 white',
    padding: '0 40px 40px',
    minHeight: '0',
    [theme.breakpoints.down('lg')]: {
      padding: '0 20px 30px',
    },
  },
  panelSummary: {
    padding: 0,
    paddingTop: '15px',

    '& .panelTitle': {
      color: theme.palette.blue1,
      fontFamily: theme.typography.proxima.bold,
      fontSize: theme.typography.pxToRem(18),
      letterSpacing: theme.typography.pxToRem(2),
      textTransform: 'uppercase',
      marginTop: '4px',
    },
  },
  panelSummaryFullPaid: {
    padding: 0,
    paddingTop: '15px',

    '& .panelTitle': {
      color: theme.palette.blue1,
      fontFamily: theme.typography.proxima.bold,
      fontSize: theme.typography.pxToRem(18),
      letterSpacing: theme.typography.pxToRem(2),
      textTransform: 'uppercase',
      marginTop: '4px',
    },
    [theme.breakpoints.down('sm')]: {
      '& .MuiAccordionSummary-expandIcon': {
        position: 'absolute',
        right: '16%',
      },
    },
  },
  panelSummaryNewLayout: {
    padding: 0,
    display: 'flex',
    maxHeight: '22px',
    minHeight: '22px',
    marginTop: '30px',
    '&.Mui-expanded': {
      minHeight: '22px',
      [theme.breakpoints.down('sm')]: {
        minHeight: '50px',
      },
    },
    '& .panelTitle': {
      color: theme.palette.blue1,
      fontFamily: theme.typography.proxima.bold,
      fontSize: theme.typography.pxToRem(18),
      letterSpacing: theme.typography.pxToRem(2),
      textTransform: 'uppercase',
      marginTop: '4px',
    },

    [theme.breakpoints.down('sm')]: {
      display: 'block',
      minHeight: '50px',
      marginTop: '30px',
      '& .MuiAccordionSummary-expandIcon': {
        position: 'absolute',
        right: '30%',
        top: '51%',
      },
    },
    [theme.breakpoints.down('xs')]: {
      '& .MuiAccordionSummary-expandIcon': {
        right: '24%',
        top: '105%',
      },
    },
  },
  expandIcon: {
    color: theme.palette.blue2,
    padding: 0,
  },
  heading: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  headingPaidInFull: {
    display: 'flex',
    justifyContent: 'right',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
    },
  },
  headingNewLAyout: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  viewPanel: {
    color: theme.palette.blue2,
    fontSize: theme.typography.pxToRem(14),
  },
  viewPanelNewLayout: {
    color: theme.palette.blue2,
    fontSize: theme.typography.pxToRem(14),
    [theme.breakpoints.down('sm')]: {
      position: 'absolute',
      right: '40%',
      top: '80%',
    },
    [theme.breakpoints.down('xs')]: {
      position: 'absolute',
      right: '34%',
      top: '134%',
    },
  },
  divider: {
    marginTop: '15px',
  },
  dividerNewLayout: {
    marginTop: '25px',
    [theme.breakpoints.down('sm')]: {
      marginTop: '30px',
    },
    [theme.breakpoints.down('xs')]: {
      marginTop: '70px',
    },
  },
  details: {
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginTop: '20px',
    '&.MuiAccordionDetails-root': {
      padding: '10px 20px 0 0',
    },

    [theme.breakpoints.down('sm')]: {
      '&.MuiAccordionDetails-root': {
        padding: 0,
      },
    },
  },
  column: {
    flexBasis: '50%',
    [theme.breakpoints.down('md')]: {
      flexBasis: '60%',
    },
    [theme.breakpoints.down('sm')]: {
      flexBasis: '100%',
    },
  },
  columnNewLayout: {
    flexBasis: '100%',
  },
  panelTitleBalance: {
    color: theme.palette.grey1,
    fontFamily: theme.typography.proxima.regular,
    fontSize: theme.typography.pxToRem(18),
    [theme.breakpoints.down('lg')]: {
      fontSize: theme.typography.pxToRem(14),
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.typography.pxToRem(16),
    },
  },
  row: {
    borderBottom: `0.5px solid ${theme.palette.divider}`,
    height: '56px',
    '&:last-child': {
      border: 'none',
    },
  },
  tableHead: {
    color: theme.palette.blue1,
    fontFamily: 'ProximaBold',
    fontSize: theme.typography.pxToRem(16),
    letterSpacing: theme.typography.pxToRem(1),
    [theme.breakpoints.down('lg')]: {
      fontSize: theme.typography.pxToRem(14),
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: theme.typography.pxToRem(12),
    },
    '& .iconHeader': {
      '& span': {
        height: '18px',
      },
      [theme.breakpoints.only('xs')]: {
        '& svg': {
          display: 'none',
        },
      },
    },
  },
  tableCell: {
    fontSize: theme.typography.pxToRem(16),
    color: theme.palette.grey1,
    '& .iconHeader': {
      '& span': {
        marginRight: '36px',
        [theme.breakpoints.down('xs')]: {
          marginRight: '0 !important',
        },
      },
    },
    [theme.breakpoints.down('lg')]: {
      fontSize: theme.typography.pxToRem(14),
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: theme.typography.pxToRem(12),
    },
  },
  creditCarardIcon: {
    paddingRight: '10px',
    '& svg': {
      width: '29px',
      height: '18px',
    },
  },
  creditCarardIconPaymentPage: {
    marginRight: '72px !important',
    [theme.breakpoints.down('lg')]: {
      marginRight: '60px !important',
    },
  },
}));

export default useStyles;
